import React from "react";
import { Button, Typography } from "antd";
import { MdClose, MdOutlineCircle, MdCheckBoxOutlineBlank, MdChangeHistory, MdOutlineImage, MdStraighten } from "react-icons/md";
import { PiTreeBold } from "react-icons/pi";

const NOTICE_ICONS = { tree: PiTreeBold, circle: MdOutlineCircle, square: MdCheckBoxOutlineBlank, triangle: MdChangeHistory, segment: MdOutlineImage, ruler: MdStraighten };

const CanvasNotice = ({ notice, theme }) => {
  if (!notice?.visible) return null;
  const actions = Array.isArray(notice.actions) ? notice.actions.filter(Boolean) : [];
  const Icon = notice.iconName ? NOTICE_ICONS[notice.iconName] : null;
  const hasIcon = !!Icon || !!notice.icon;
  const close = typeof notice.onClose === "function"
    ? notice.onClose
    : notice.cancelable
      ? () => window.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", code: "Escape", bubbles: true, cancelable: true }))
      : null;

  return (
    <div className={`canvas-notice ui-card ui-card--surface-2 ${theme ? "dark" : ""} ${notice.intent ? `is-${notice.intent}` : ""} ${actions.length ? "has-actions" : ""} ${hasIcon ? "has-icon" : ""}`} role="status" aria-live="polite">
      {close ? <button type="button" className="canvas-notice-close" aria-label={notice.closeLabel || "Cancel"} title="Cancel (Esc)" onClick={close}><MdClose /></button> : null}
      {hasIcon ? <span className="canvas-notice-icon" aria-hidden="true">{Icon ? <Icon /> : notice.icon}</span> : null}
      {/* The body is always the layout column. Ant's Typography.Text renders an
          inline <span>, so an unclassed wrapper let the title and subtitle run
          together on one line and slide under the close button. */}
      <div className="canvas-notice-body">
        <Typography.Text className="canvas-notice-title">{notice.title}</Typography.Text>
        {notice.subtitle ? <Typography.Text className="canvas-notice-subtitle">{notice.subtitle}</Typography.Text> : null}
        {actions.length ? <div className="canvas-notice-actions">{actions.map((action) => <Button key={action.key || action.label} type={action.type || "default"} size="small" disabled={action.disabled} className={`canvas-notice-action ${action.className || ""}`.trim()} onClick={action.onClick}>{action.label}</Button>)}</div> : null}
      </div>
    </div>
  );
};

export default CanvasNotice;
